<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (open) {
  <div
    #overlay
    class="overlay">
    <!-- htmllint id-class-style="false" -->
    <div
      [class]="'render-modal-panel__modal ' + modalType()"
      @ModalInOut>
      <div
        class="content e2e-content-modal"
        cdkTrapFocus
        [cdkTrapFocusAutoCapture]="!isMobile">
          <ng-content></ng-content>
      </div>

      @if (hasToShowCloseButton()) {
        <button
          type="button"
          (click)="close()"
          class="close-modal e2e-close-modal">
          <svg
            viewBox="0 0 28 28"
            fill="none">
            <path
              d="M0.898371 1.01361C1.24203 0.669944 1.79922 0.669944 2.14288 1.01361L13.8406 12.7114L25.5384 1.01361C25.882 0.669944 26.4392 0.669944 26.7829 1.01361C27.1265 1.35727 27.1265 1.91445 26.7829 2.25811L15.0851 13.9559L26.7829 25.6536C27.1265 25.9973 27.1265 26.5545 26.7829 26.8981C26.4392 27.2418 25.882 27.2418 25.5384 26.8981L13.8406 15.2004L2.14288 26.8981C1.79922 27.2418 1.24203 27.2418 0.898371 26.8981C0.55471 26.5545 0.55471 25.9973 0.898371 25.6536L12.5961 13.9559L0.898371 2.25811C0.55471 1.91445 0.55471 1.35727 0.898371 1.01361Z"/>
          </svg>
        </button>
      }
    </div>
  </div>
}
